export default __webpack_public_path__ + "static/ghs-87166c8ee9b34401f63fb843b017b736.png";